module.exports = __webpack_public_path__ + "img/green-tick.0f92a53f.svg";